// Iter 205 — Page publique CGV (contenu servi par /api/cgv, source unique backend).
import React, { useEffect, useState } from 'react';
import PageBanner from '../components/PageBanner';

const API = process.env.REACT_APP_BACKEND_URL;

const slug = (t) => t.toLowerCase().replace(/[^a-z0-9]+/g, '-');

export default function CGV() {
  const [cgv, setCgv] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetch(`${API}/api/cgv`).then(r => r.json()).then(setCgv).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF7F2]" data-testid="cgv-page">
      <PageBanner title="Conditions générales de vente" subtitle="Des voyages entre amis ou en famille" />
      <div className="container-custom py-10 max-w-4xl mx-auto">
        {!cgv ? (
          <p className="text-center text-gray-400 py-16">Chargement…</p>
        ) : (
          <>
            <div className="bg-white rounded-2xl shadow-sm p-6 md:p-8 mb-6">
              <div className="flex flex-wrap items-center justify-between gap-3">
                <div>
                  <p className="text-sm font-bold text-[#1E3A5F]">{cgv.entete.association}</p>
                  <p className="text-xs text-gray-500 mt-1">
                    Mise à jour du <strong>{cgv.date_maj}</strong> · SIRET {cgv.entete.siret} · {cgv.entete.email} · {cgv.entete.telephone}
                  </p>
                </div>
                <a href={`${API}/api/cgv.pdf`} target="_blank" rel="noopener noreferrer"
                  data-testid="cgv-download-pdf"
                  className="inline-flex items-center gap-2 bg-[#1E3A5F] hover:bg-[#2a4d7a] text-white text-xs font-bold px-4 py-2.5 rounded-lg transition-colors">
                  📄 Télécharger le PDF
                </a>
              </div>
              <div className="mt-4 border-t border-gray-100 pt-4">
                <p className="text-[11px] font-bold text-gray-400 uppercase mb-2">Sommaire</p>
                <div className="flex flex-wrap gap-1.5">
                  {cgv.articles.map(a => (
                    <a key={a.titre} href={`#${slug(a.titre)}`}
                      className="text-[11px] bg-gray-100 hover:bg-[#5BC5D4] hover:text-white text-gray-600 rounded-full px-2.5 py-1 transition-colors">
                      {a.titre}
                    </a>
                  ))}
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-sm p-6 md:p-10">
              {cgv.articles.map(a => (
                <section key={a.titre} id={slug(a.titre)} className="mb-8" data-testid={`cgv-article-${slug(a.titre)}`}>
                  <h2 className="text-lg font-bold text-[#1E3A5F] mb-3 border-l-4 border-[#5BC5D4] pl-4">{a.titre}</h2>
                  <div className="text-gray-700 leading-relaxed text-sm space-y-2">
                    {a.paragraphes.map((p, i) => p.startsWith('• ')
                      ? <p key={i} className="ml-5 relative"><span className="absolute -left-4 text-[#5BC5D4] font-bold">•</span>{p.slice(2)}</p>
                      : <p key={i}>{p}</p>)}
                  </div>
                </section>
              ))}
              <p className="text-xs text-gray-400 italic text-center border-t border-gray-100 pt-6">
                Les présentes conditions annulent et remplacent toute version antérieure — version en vigueur mise à jour le {cgv.date_maj}.
                En cas de divergence avec les informations publiées sur le site, les documents contractuels font foi.
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
